import { RegularScaleButton } from '@bit/wavfichacerta.fichacerta.shared-styles.buttons';
import React, { PureComponent } from 'react';
import { noRepeatproduct, removeProduct } from '../../utils/operational/requests/productsHelper';
import { EntityChoiceBody, StyledRowComponent } from '../shared/entity-choice/entityChoice.styled.js';
import EntityChoiceButtonGroupUnlinked from '../shared/entity-choice/EntityChoiceButtonGroupUnlinked.js';
import { DisabledOverlay } from './entityChoiceContent.styled';
import ProductCardboard from './ProductCardboard';

import ReactTooltip from 'react-tooltip'
import TourTooltip from '../shared/TourTooltip';

class EntityChoiceContent extends PureComponent {
  static defaultProps = {
    showGoBack: false
  }

  state = {
    entity: 'FISICA',
    products: []
  }

  renderProducts = () => {
    const { list } = this.props;
    const catalog = {
      1: { entity: 'FISICA', icon: 'FcRapida', title: 'FC REPORT', description: <span>FC REPORT: Score FC + Risco FC + Dados Pessoais/Financeiros + Negativações + Ações Judiciais</span> },
      3: { entity: 'FISICA', icon: 'FcRapida', title: 'FC ESSENCIAL', description: "INCLUIR\nAnálise FC para Locação + Ações Locatícias e Criminais" },
      5: { entity: 'FISICA', icon: 'Document', title: 'FC BASICO', description: <span>INCLUIR Consultas de Dados, Restrições, Ações Locatícias, Cíveis e Criminais</span> },
      7: { entity: 'FISICA', icon: 'FcRapida', title: 'FC COMPLETA', description: <span>FC COMPLETA: FC REPORT + FC DOC (Análise de Documentos pela mesa de Analistas FC)</span> },
      9: { entity: 'FISICA', icon: 'FcRapida', title: 'FC SCORE', description: <span>FC SCORE: Score FC + Risco FC + Dados Pessoais</span> },
      10: { entity: 'FISICA', icon: 'FcRapida', title: 'FC SCORE+', description: <span>FC SCORE+: Score FC + Risco FC + Dados Pessoais + Ações Judiciais</span> },
      4: { entity: 'JURIDICA', icon: 'FcRapida', title: 'FC EMPRESA', description: "INCLUIR\nAnálise do perfil de risco para locação: FC EMPRESA" },
      8: { entity: 'JURIDICA', icon: 'FcRapida', title: 'FC COMPLETA', description: "INCLUIR\nAnálise FC + Restrições + Ações + Documentos" }
    };

    const products = list
      .filter(({ id, servico }) =>
        id &&
        catalog[id] &&
        catalog[id].entity === this.state.entity &&
        !servico &&
        ![13, 14].includes(Number(id))
      )
      .map((product) => {
        const { valor, id, valor_editavel } = product;
        const price = valor_editavel > 0 ? valor_editavel : valor;
        const current = catalog[id];

        return (
          <ProductCardboard
            key={id}
            isTrashVisible={false}
            id={id}
            onSelect={this.selectProduct(product.id)}
            active={this.state.entity !== undefined}
            selected={this.isProductSelected(product.id)}
            icon={current.icon}
            title={current.title}
            price={price}
            description={current.description}
          />
        );
      });

    return products;
  }

  addProduct = (id) => {
    this.setState({ products: noRepeatproduct(id, this.state.products) }, () => {
      this.goForward()
    });
  }

  removeProduct = (id) => {
    this.setState({ products: removeProduct(id, this.state.products) });
  }

  selectProduct = (id) => () => {
    if (this.isProductSelected(id)) {
      this.removeProduct(id);
    } else {
      this.addProduct(id)
    }
  }

  isProductSelected = (id) => {
    const { products } = this.state;
    const productIndex = products.findIndex(prtId => prtId === id);

    return productIndex !== -1;
  }

  selectEntity = (entity) => {
    this.setState({ entity, products: [] });
  }

  isGoForwardDisabled = () => this.state.products.length === 0

  goForward = () => {
    const { products, entity } = this.state;

    this.props.goForward(products, entity);
  }

  renderGoBackButton = () => {
    if (this.props.showGoBack) {
      return (
        <RegularScaleButton
          onClick={this.props.onGoBack}
          color="color_white"
          background="color_purple"
          padding="8px 22px"
          customstyle={{
            width: '110px',
            height: '36px',
            padding: '0 1rem',
            margin: '0 .5rem',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            lineHeight: 1,
            borderRadius: '10px',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            background: 'linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%)',
            boxShadow: '0 1px 0 rgba(255, 255, 255, 0.12) inset, 0 2px 6px rgba(21, 43, 78, 0.25)',
            textTransform: 'uppercase',
            letterSpacing: '.04em',
            fontWeight: 600
          }}
        >
          {this.props.cancel ? "Cancelar" : "Voltar"}
        </RegularScaleButton>
      );
    }

    return null;
  }

  render() {
    const { list } = this.props
    const fcEmpresa = list.filter(product => product.id === 4 || product.id === 8)
    const tooltipChipStyle = {
      position: 'relative',
      top: 0,
      right: 'auto',
      left: 'auto',
      marginLeft: 0,
      flexShrink: 0,
    }

    const selectTypeTooltipStyle = {
      position: 'absolute',
      top: 6,
      right: 6,
      left: 'auto',
      margin: 0,
      zIndex: 3,
    }

    return (
      <EntityChoiceBody>
        <StyledRowComponent styles="padding: .35rem 0 1.1rem 0 !important;">
          <div
            className="container-select-type entity-choice-type-row"
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              width: '100%',
            }}
          >
            <EntityChoiceButtonGroupUnlinked
              entity={this.state.entity}
              onClick={this.selectEntity}
              fcEmpresa={fcEmpresa}
              firstButtonCornerHelp={(
                <TourTooltip target="tooltip-select-type" style={selectTypeTooltipStyle} />
              )}
            />
            <ReactTooltip id="tooltip-select-type" place="bottom" type="dark" effect="float">
              O produto Pessoa Física já vem selecionado, mas caso deseje inserir uma consulta PJ basta clicar em Pessoa Jurídica.
            </ReactTooltip>
          </div>
       </StyledRowComponent>
       <StyledRowComponent customstyle={{ textAlign: 'center' }} styles="padding: 0 0 1.25rem 0 !important;">
          {this.state.entity === undefined && <DisabledOverlay />}
          <div
            className="container-cards-products entity-choice-products-row"
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '14px',
              justifyContent: 'center',
              alignItems: 'flex-start',
              width: '100%',
            }}
          >
            {this.renderProducts()}
            <TourTooltip target="tooltip-select-product" style={tooltipChipStyle} />
            <ReactTooltip id="tooltip-select-product" place="top" type="dark" effect="float">
              Selecione o produto disponível e avance
            </ReactTooltip>
          </div>
        </StyledRowComponent>
        
        <StyledRowComponent styles="padding: .1rem 0 .95rem 0 !important;">
          {this.renderGoBackButton()}
          {/* <RegularScaleButton
            onClick={this.goForward}
            disabled={this.isGoForwardDisabled()}
            color="color_white"
            background={this.isGoForwardDisabled() ? 'color_gray' : 'color_purple'}
            customstyle={{'width': '90px', 'height': '33px', 'padding': '0 1rem 0 1rem', 'margin': '0 .5rem 0 .5rem'}}
          >
            Avançar
          </RegularScaleButton> */}
        </StyledRowComponent>
      </EntityChoiceBody>
    );
  }
}

export default EntityChoiceContent;
